import React, { Component } from 'react';
import Checkbox from '@material-ui/core/Checkbox';
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';
class getCerrar extends Component {

  constructor(props){
     super(props);
     this.state = {
       buscar_cliente:'',
       codigo_cliente:'',
       nombre_cliente:'',
       correo_cliente:'',
       telefono_cliente:'',
       direccion_cliente:'',
       id_codigo_cliente:0,
       descuento_final:'',
       propina_final:'',
       id_forma_pago:1,
       precio_total:0,
       sw_consumidor_final:0,
       sw_tipo_descuento:0,
       subfinal:this.props.precio_total,
       valor_descuento:0,
       clientes:null,
       id_empresa:this.props.id_empresa
     }
     this.handleInputChange = this.handleInputChange.bind(this);
   }
   getFinalizarCuenta =()=>{
     const subfinal = Number(this.state.subfinal)
     const valor_descuento = Number(this.state.valor_descuento)
     const propina_final = Number(this.state.propina_final)
     const precio_total = Number(this.state.precio_total)
     const sw_consumidor_final = Number(this.state.sw_consumidor_final)
     const id_forma_pago = Number(this.state.id_forma_pago)


     const nombre_cliente = this.state.nombre_cliente
     const codigo_cliente = this.state.codigo_cliente
     const telefono_cliente = this.state.telefono_cliente
     const direccion_cliente = this.state.direccion_cliente
     const correo_cliente = this.state.correo_cliente
     if(sw_consumidor_final===1){
         if(nombre_cliente.trim()===''){
          this.setState({
            msg : "Ingrese Razón Social / Nombre"
          })
          return
        }
        if(codigo_cliente.trim()===''){
          this.setState({
            msg : "Ingrese RUC / Cédula / Pasaporte"
          })
          return
        }
        if(telefono_cliente.trim()===''){
          this.setState({
            msg : "Ingrese Teléfono"
          })
          return
        }
        if(direccion_cliente.trim()===''){
          this.setState({
            msg : "Ingrese Dirección"
          })
          return
        }
        if(correo_cliente.trim()===''){
          this.setState({
            msg : "Ingrese Mail"
          })
          return
        }
        if(!this.validateEmail(correo_cliente)){
          this.setState({
            msg : "Mail Incorrecto"
          })
          return
        }
     }
     confirmAlert({
         title: 'Finalizar Cuenta',
         message: '¿Desea Finalizar Pedido?',
         buttons: [
           {
             label: 'Sí',
             onClick: () => this.get_opcion_no
           },
           {
             label: 'No',
             onClick: () => this.get_opcion_no()
           }
         ]
       })
   }
   get_opcion_no =()=>{

   }
   validateEmail = (email) => {
      return /^[A-Za-z0-9._%-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,4}$/.test(email)
   }
   getCalcularTotales =()=>{
     const subfinal = this.state.subfinal
     this.setState({
       precio_total:subfinal
     })
   }
  setFormaPago =(id_forma_pago)=>{
    this.setState({
      id_forma_pago
    })
  }
  getDescuento =()=>{
    const sw_tipo_descuento = this.state.sw_tipo_descuento
    if(Number(sw_tipo_descuento)===0){
      this.setState({
        sw_tipo_descuento:1
      })
    }else{
      this.setState({
        sw_tipo_descuento:0
      })
    }
  }
  handleInputChange(event) {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;
    if(name==='buscar_cliente'){
      this.setState({
        [name]: value
      },()=>{
        this.getClientes()
      });
    }else{
      this.setState({
        [name]: value
      });
    }


  }
  getClientes =()=>{
    const buscar_cliente = this.state.buscar_cliente
    if((buscar_cliente.trim())===''){
      this.setState({
        clientes :null
      })
      return
    }
      const url= this.props.url_proxyurl + this.props.url_global + "webservices/getCClientes/";
     var obj = { buscar_cliente };
      fetch(url, {
        method: 'POST',
        body: JSON.stringify(obj),
        headers:{
          'Accept':'application/json',
          'Content-Type': 'application/json'
        }
      })
      .then(res => res.json())
      .then((data) => {
        if(data[0].status==="ok"){
          this.setState({
            clientes :data[0].msg
          })
        }else{
          this.setState({
            clientes :null,
            codigo_cliente:buscar_cliente
          })
        }
      })
      .catch(console.log)
  }
  getConsumidor =()=>{
    const sw_consumidor_final = this.state.sw_consumidor_final
    if(Number(sw_consumidor_final)===0){
      this.setState({
        sw_consumidor_final:1
      })
    }else{
      this.setState({
        sw_consumidor_final:0,
        buscar_cliente:'',
        codigo_cliente:'',
        nombre_cliente:'',
        correo_cliente:'',
        telefono_cliente:'',
        direccion_cliente:'',
        id_codigo_cliente:0,
        clientes:null
      })
    }
  }
  getGrabar =()=>{

    const nombre_cliente = this.state.nombre_cliente
    const codigo_cliente = this.state.codigo_cliente
    const telefono_cliente = this.state.telefono_cliente
    const direccion_cliente = this.state.direccion_cliente
    const correo_cliente = this.state.correo_cliente
    const id_codigo_cliente = Number(this.state.id_codigo_cliente)
    const sw_consumidor_final = this.state.sw_consumidor_final
    //if(id_codigo_cliente===0){
      if(sw_consumidor_final===1){
        if(nombre_cliente.trim()===''){
         this.setState({
           msg : "Ingrese Razón Social / Nombre"
         })
         return
       }
       if(codigo_cliente.trim()===''){
         this.setState({
           msg : "Ingrese RUC / Cédula / Pasaporte"
         })
         return
       }

       //const id_forma_juridica = this.validateCodigo(codigo)
      const id_forma_juridica = this.validateCodigo(codigo_cliente)
      if(!id_forma_juridica){
        this.setState({
          msg: 'RUC/Cédula/Pasaporte Incorrecto'
        })
        return null
      }


       if(telefono_cliente.trim()===''){
         this.setState({
           msg : "Ingrese Teléfono"
         })
         return
       }
       if(direccion_cliente.trim()===''){
         this.setState({
           msg : "Ingrese Dirección"
         })
         return
       }
       if(correo_cliente.trim()===''){
         this.setState({
           msg : "Ingrese Mail"
         })
         return
       }
       if(!this.validateEmail(correo_cliente)){
         this.setState({
           msg : "Mail Incorrecto"
         })
         return
       }



        //c//onst id_forma_juridica = 0;
        const url= this.props.url_proxyurl + this.props.url_global + "webservices/setCClientes/";
        var obj = { codigo_cliente,nombre_cliente,correo_cliente,telefono_cliente,direccion_cliente,id_codigo_cliente,id_forma_juridica };
          fetch(url, {
            method: 'POST',
            body: JSON.stringify(obj),
            headers:{
              'Accept':'application/json',
              'Content-Type': 'application/json'
            }
          })
          .then(res => res.json())
          .then((data) => {
            if(data[0].status==="ok"){
              /*this.setState({
                clientes :data[0].msg
              })*/
              this.props.getRegresarC(data[0].id_codigo_cliente);
            }else{
              this.props.getRegresarC(0);
            }
          })
          .catch(console.log)
        }else{
          this.props.getRegresarC(0);
        }
    //}else{
     // this.props.getRegresarC(0);
    //}
    //console.log(id_codigo_cliente)
    //this.props.getRegresarC(id_codigo_cliente);
  }


  validateCodigo =(codigo)=>{
    if(codigo){
      const len_string= codigo.length
      if(len_string>3&&len_string<=15){
        const ext = codigo.substring(len_string-2, len_string).trim();
        if(ext.toUpperCase()==='EX'){
          return 2;
        }
      }
      if(len_string===10){
        if(codigo==='9999999999'){
          return false
        }
      }
      if(len_string===13){
        if(codigo==='9999999999999'){
          return false
        }
        const ext = codigo.substring(len_string-3, len_string).trim()
        if(ext!=='001'){
          return false;
        }
      }
      let sum_pa=0
      let sum_im=0
      for(var i=1;i<9;i=i+2){
          sum_pa = Number(codigo.substring(i, i+1)) + sum_pa
      }
      for(var i=0;i<9;i=i+2){
          let valor = Number(codigo.substring(i, i+1))*2
          if(valor>9){
            valor=valor-9
          }
          sum_im=sum_im+valor
      }
      let  tot=sum_pa+sum_im
      while(tot>10){
              tot=tot-10;
      }
 	    tot=10-tot
      const ult_dig= Number(codigo.substring(9,10))
    	if (tot==ult_dig){
        if(len_string===13){
          return 1
        }else{
          if(len_string===10){
            return 2
          }else{
            return false
          }
        }
      }else{

    	}
      if((Number(codigo.substring(2,3))===6||Number(codigo.substring(2,3))===9)&&len_string===13){
        return 1
      }

      return false

    }else{
      return false
    }
  }

  getRegresar =()=>{
    
    const id_codigo_cliente = this.state.id_codigo_cliente 
    //console.log(id_codigo_cliente)
    this.props.getRegresarC(id_codigo_cliente);
  }
  getDatoClientes =(cliente)=>{
    this.setState({
      buscar_cliente:'',
      codigo_cliente:cliente.codigo,
      nombre_cliente:cliente.cliente,
      correo_cliente:cliente.email,
      telefono_cliente:cliente.telefono_trabajo,
      direccion_cliente:cliente.direccion,
      id_codigo_cliente:cliente.id_empresa,
      clientes:null
    })
  }
  getDataBusqueda =()=>{
    const clientes = this.state.clientes
    return(
       <React.Fragment>
       {(clientes)?
       <React.Fragment>
         <table className="tb_pedidos">
         <thead>
         <tr >
           <th>Cliente</th>
           <th>Código</th>
         </tr>
         </thead>
         <tbody>
          {clientes.map((cliente , index) => (
            <React.Fragment key={index}>
            <tr onClick={ () => this.getDatoClientes(cliente) }>
              <td>{cliente.cliente}</td>
              <td>{cliente.codigo}</td>
            </tr>
            </React.Fragment>
          ) ) }
        </tbody>
        </table>
      </React.Fragment>
      :
      <React.Fragment>
        <div className="grid-cssversion_content_global cssversion_pw100 cssversion_phx30" >
         <input style={{"fontSize":"15pt"}}  disabled={Number(this.state.sw_consumidor_final)===0?true:false} value={this.state.codigo_cliente} onChange={this.handleInputChange} name="codigo_cliente" className="input-global cssversion_pw100" placeholder="RUC/CI/PASAPORTE" />
        </div>
        <div className="grid-cssversion_content_global cssversion_pw100 cssversion_phx30" >
         <input style={{"fontSize":"15pt"}}  disabled={Number(this.state.sw_consumidor_final)===0?true:false} value={this.state.nombre_cliente} onChange={this.handleInputChange} name="nombre_cliente" className="input-global cssversion_pw100" placeholder="Razón Social" />
        </div>
        <div className="grid-cssversion_content_global cssversion_pw100 cssversion_phx30" >
         <input style={{"fontSize":"15pt"}}  disabled={Number(this.state.sw_consumidor_final)===0?true:false} value={this.state.correo_cliente} onChange={this.handleInputChange} name="correo_cliente"  className="input-global cssversion_pw100" placeholder="Correo Electrónico" />
        </div>
        <div className="grid-cssversion_content_global cssversion_pw100 cssversion_phx30" >
         <input style={{"fontSize":"15pt"}}  disabled={Number(this.state.sw_consumidor_final)===0?true:false} value={this.state.telefono_cliente} onChange={this.handleInputChange} name="telefono_cliente"  className="input-global cssversion_pw100" placeholder="Telefóno" />
        </div>
        <div className="grid-cssversion_content_global cssversion_pw100 cssversion_phx30" >
         <input style={{"fontSize":"15pt"}}  disabled={Number(this.state.sw_consumidor_final)===0?true:false} value={this.state.direccion_cliente} onChange={this.handleInputChange} name="direccion_cliente"  className="input-global cssversion_pw100" placeholder="Dirección" />
        </div>
        </React.Fragment>
      }
      </React.Fragment>
    )
  }

  render (){
    return (
      //background-color: #2b1d1d91;
       <div className="grid-cssversion_content_global cssversion_pw100 cssversion_ph100" style={{"backgroundColor":"#2b1d1d91"}} >
         <div className="grid-cssversion_content_global cssversion_pw100 cssversion_ph100 cssversion_contentCenter">
           <div className="grid-cssversion_content_global cssversion_pw90 cssversion_ph100" >
             <div className="grid-cssversion_content_global cssversion_pw100 cssversion_phx30 cssversion_contentCenter" >
              <span className="span-global-info" style={{"fontSize":"15pt","color":"white"}}>Datos del Cliente</span>
             </div>
             <div className="grid-cssversion_content_global cssversion_pw100 cssversion_phx30 cssversion_contentCenter"  onClick={ () => this.getConsumidor() }>
              <span  className="span-global-info" style={{"fontSize":"15pt","color":"white"}}>Consumidor Final</span> <Checkbox checked={Number(this.state.sw_consumidor_final)===0?true:false}  inputProps={{ 'aria-label': 'primary checkbox' }}/>
             </div>
             <div className="grid-cssversion_content_global cssversion_pw100 cssversion_phx30 " >
              <input style={{"background-color":"orange","fontSize":"15pt"}} disabled={Number(this.state.sw_consumidor_final)===0?true:false} value={this.state.buscar_cliente} onChange={this.handleInputChange} name="buscar_cliente" className="input-global cssversion_pw100" placeholder="Buscar por Nombre o Código" />
             </div>
             {this.getDataBusqueda()}
             <br/>
             <button style={{"backgroundColor":"black"}} className="button-global cssversion_pw100" onClick={ () => this.getGrabar()}>
              <span className="span-global-info"  style={{"fontSize":"15pt","color":"white"}}>Grabar</span>
            </button>
            <br/><br/>
             <button style={{"backgroundColor":"black"}}  className="button-global cssversion_pw100" onClick={ () => this.getRegresar()}>
              <span className="span-global-info"  style={{"fontSize":"15pt","color":"white"}}>Regresar</span>
            </button>
            <br/>
            <span style={{"color":"red"}}>{this.state.msg}</span>
           </div>
           
         </div>
       </div>
    )
  }
  componentDidMount() {
    this.getCalcularTotales()
    const id_empresa = Number(this.state.id_empresa)
    if(id_empresa>0){
      const url= this.props.url_proxyurl + this.props.url_global + "webservices/getIDClientes/";
      var obj = { id_empresa };
        fetch(url, {
          method: 'POST',
          body: JSON.stringify(obj),
          headers:{
            'Accept':'application/json',
            'Content-Type': 'application/json'
          }
        })
        .then(res => res.json())
        .then((data) => {
          if(data[0].status==="ok"){
            this.setState({
              codigo_cliente:data[0].msg[0].codigo,
              nombre_cliente:data[0].msg[0].cliente,
              correo_cliente:data[0].msg[0].email,
              telefono_cliente:data[0].msg[0].telefono_trabajo,
              direccion_cliente:data[0].msg[0].direccion,
              id_codigo_cliente:data[0].msg[0].id_empresa,
              sw_consumidor_final:1
            })
          }else{
             
          }
        })
        .catch(console.log)
    }
  }
}
export default getCerrar;
/*<div className="grid-cssversion_content_global cssversion_pw50 cssversion_ph100" >
             <div className="grid-cssversion_content_global cssversion_pw100 cssversion_phx30 cssversion_contentCenter" >
              <span className="span-global-info">Valores</span>
             </div>
             <div className="grid-cssversion_content_global cssversion_pw100 cssversion_phx30 cssversion_contentCenter" >
               <div className="grid-cssversion_content_global cssversion_pw20 cssversion_ph100" >
                <span className="span-global-info">SubFinal</span>
               </div>
               <div className="grid-cssversion_content_global cssversion_pw80 cssversion_ph100" >
                <span className="span-global-info">{Number(this.state.subfinal).toFixed(2)}</span>
               </div>
             </div>
             <div className="grid-cssversion_content_global cssversion_pw100 cssversion_phx30 cssversion_contentCenter" >
               <div className="grid-cssversion_content_global cssversion_pw20 cssversion_ph100" >
                <span className="span-global-info">Descuento</span>
               </div>
               <div className="grid-cssversion_content_global cssversion_pw60 cssversion_ph100" >
                <input value={this.state.descuento_final} onChange={this.handleInputChange} name="descuento_final"  className="input-global cssversion_pw90" placeholder="Descuento" />
               </div>
               <div className="grid-cssversion_content_global cssversion_pw20 cssversion_ph100" onClick={ () => this.getDescuento() }>
                <Checkbox checked={Number(this.state.sw_tipo_descuento)===0?true:false} inputProps={{ 'aria-label': 'primary checkbox' }}/><span className="span-global-info"> Porcentaje</span>
               </div>
             </div>
             <div className="grid-cssversion_content_global cssversion_pw100 cssversion_phx30 cssversion_contentCenter" >
               <div className="grid-cssversion_content_global cssversion_pw20 cssversion_ph100" >
                <span className="span-global-info">Propina</span>
               </div>
               <div className="grid-cssversion_content_global cssversion_pw80 cssversion_ph100" >
                <input value={this.state.propina_final} onChange={this.handleInputChange} name="propina_final"  className="input-global cssversion_pw90" placeholder="Propina" />
               </div>
              </div>
             <div className="grid-cssversion_content_global cssversion_pw100 cssversion_phx30 cssversion_contentCenter" >
               <div className="grid-cssversion_content_global cssversion_pw20 cssversion_ph100" >
                <span className="span-global-info">Total</span>
               </div>
               <div className="grid-cssversion_content_global cssversion_pw80 cssversion_ph100" >
                <span className="span-global-info">{Number(this.state.precio_total).toFixed(2)}</span>
               </div>
             </div>
             <div className="grid-cssversion_content_global cssversion_pw100 cssversion_phx30 cssversion_contentCenter" >
               <div className="grid-cssversion_content_global cssversion_pw20 cssversion_ph100" >
                <span className="span-global-info">Forma de Pago</span>
               </div>
               <div className="grid-cssversion_content_global cssversion_pw20 cssversion_ph100 " onClick={ () => this.setFormaPago(1) }>
                <Checkbox checked={Number(this.state.id_forma_pago)===1?true:false} inputProps={{ 'aria-label': 'primary checkbox' }}/> <span className="span-global-info">Efectivo</span>
               </div>
               <div className="grid-cssversion_content_global cssversion_pw20 cssversion_ph100 " onClick={ () => this.setFormaPago(3) }>
                <Checkbox checked={Number(this.state.id_forma_pago)===3?true:false} inputProps={{ 'aria-label': 'primary checkbox' }}/> <span className="span-global-info">Tarjeta</span>
               </div>
               <div className="grid-cssversion_content_global cssversion_pw20 cssversion_ph100 " onClick={ () => this.setFormaPago(7) }>
                <Checkbox checked={Number(this.state.id_forma_pago)===7?true:false} inputProps={{ 'aria-label': 'primary checkbox' }}/> <span className="span-global-info">Transferencia</span>
               </div>
               <div className="grid-cssversion_content_global cssversion_pw20 cssversion_ph100 " onClick={ () => this.setFormaPago(2) }>
                <Checkbox checked={Number(this.state.id_forma_pago)===2?true:false} inputProps={{ 'aria-label': 'primary checkbox' }}/> <span className="span-global-info">Cheque</span>
               </div>
             </div>
             <div className="grid-cssversion_content_global cssversion_pw100 cssversion_ph10 cssversion_contentCenter" >
               <button className="button-global cssversion_pw85" onClick={ () => this.getFinalizarCuenta()}>
                 <span className="span-global-info">Finalizar Cuenta</span>
               </button>
             </div>
             <div className="grid-cssversion_content_global cssversion_pw100 cssversion_ph10 cssversion_contentCenter" >
               <button className="button-global cssversion_pw85" onClick={ () => this.getRegresar()}>
                 <span className="span-global-info">Regresar</span>
               </button>
             </div>
           </div>*/